// libraries
import React from "react";
import { Dropdown, Button, Grid, Form } from "semantic-ui-react";
import PropTypes from "prop-types";
import { filter, isEmpty, map } from "lodash";
import moment from "moment";

// redux
import { connect } from "react-redux";

// components
import Input from "@Components/Input";
import IKModal from "@Components/IkModal";

// styles
import styles from "./styles.module.css";

// staticData
import stateOptions from "./staticData";

const FilterForm = ({
	onFilter,
	onClose,
	channel,
	setChannel,
	template,
	setTemplate,
	startDateSent,
	setStartDateSent,
	endDateSent,
	setEndDateSent,
	startDateConfirmed,
	setStartDateConfirmed,
	endDateConfirmed,
	setEndDateConfirmed,
	name,
	setName,
	phone,
	setPhone,
	channelAll,
	setChannelAll,
	templateAll,
	setTemplateAll,
	channelOption,
	templateOption,
	setTemplateTable,
	templateTable,
	state,
	setState,
	group,
	setGroup,
	optionGroup,
	company,

	setIsFilterFirtTime,
}) => {
	const handlerFilter = () => {
		const filters = {
			"templateLogs.channelId[]": channel,
			"templateLogs.templateId[]": template || templateTable,
			"templateLogs.createdDate": startDateSent || endDateSent ? `${startDateSent},${endDateSent}` : "",
			"templateLogs.confirmedDate": startDateConfirmed || endDateConfirmed ? `${startDateConfirmed},${endDateConfirmed}` : "",
			name,
			phone,
			"templateLogs.confirmedDate~": state === "confirmadas" ? "si" : "",
			"templateLogs.error~": state === "error" ? "si" : "",
			"templateLogs.createdDate~": state === "enviadas" ? "si" : "",
			"id*": state === "sinenviar" ? "si" : "",
			"templateLogs.group": group,
		};

		if (!isEmpty(template)) {
			setTemplateTable("");
		}
		setIsFilterFirtTime(true);
		onFilter(filters);
	};

	const handleClear = () => {
		setChannel("");
		setTemplate("");
		setStartDateSent("");
		setEndDateSent("");
		setStartDateConfirmed("");
		setEndDateConfirmed("");
		setName("");
		setPhone("");
		setState("");
		setGroup("");
	};

	const channelHandler = (value) => {
		setChannelAll(false);
		setChannel(value);
	};

	const checkHandler = (checked) => {
		if (checked) {
			const allItems = map(
				filter(channelOption, (item) => {
					return item.value !== "all";
				}),
				(item) => {
					return item.value;
				}
			);

			setChannel(allItems);
			setChannelAll(checked);
		} else {
			setChannel([]);
			setChannelAll(checked);
		}
	};

	const templateHandler = (value) => {
		setTemplateAll(false);
		setTemplate(value);
	};

	const groupHandler = (value) => {
		setGroup(value);
	};

	const onChangeState = (value) => {
		if (value === "") {
			setState("");
		}

		setState(value);
	};

	const checkHandlerTemplate = (checked) => {
		if (checked) {
			const allItems = map(
				filter(templateOption, (item) => {
					return item.value !== "all";
				}),
				(item) => {
					return item.value;
				}
			);

			setTemplate(allItems);
			setTemplateAll(checked);
		} else {
			setTemplate([]);
			setTemplateAll(checked);
		}
	};
	return (
		<IKModal
			iconName="filter"
			title="Filtros de Plantillas"
			saveLabel="Buscar"
			noMode
			onClose={onClose}
			onSuccess={handlerFilter}
			fullHeight
			headerButtons={[
				<div className={styles.headerButtons}>
					<Button
						className={styles.clean}
						icon="trash"
						onClick={() => {
							handleClear();
						}}>
						Limpiar
					</Button>
				</div>,
			]}>
			<Grid className={styles.container} padded={false} stackable>
				<Grid.Row className={styles.row} columns={2}>
					<Grid.Column>
						<label className={styles.text}>Canal</label>
						<div className={styles.divIsPromo}>
							<label className={styles.Active}>Todas</label>
							<Form.Checkbox
								checked={channelAll}
								label={channelAll ? "si" : "No"}
								onChange={(e, { checked }) => {
									checkHandler(checked);
								}}
							/>
						</div>
						<Dropdown
							placeholder="Seleccione un Canal"
							fluid
							selection
							value={channel || channelAll}
							search
							// disabled={state === "sinenviar"}
							multiple
							onChange={(e, { value }) => {
								return channelHandler(value);
							}}
							clearable
							options={channelOption}
						/>
					</Grid.Column>
					<Grid.Column className={styles.stateSend}>
						<label className={styles.text}>Estado</label>
						<Dropdown
							placeholder="Seleccione un estado"
							fluid
							selection
							value={state}
							search
							onChange={(e, { value }) => {
								return onChangeState(value);
							}}
							clearable
							options={stateOptions}
						/>
					</Grid.Column>
				</Grid.Row>

				<Grid.Row className={styles.row} columns={2}>
					<Grid.Column className={styles.columnDate}>
						<Form.Field>
							<label className={styles.text}>Plantilla:</label>
							<div className={styles.divIsPromo}>
								<label className={styles.Active}>Todas</label>
								<Form.Checkbox
									checked={templateAll}
									label={templateAll ? "si" : "No"}
									onChange={(e, { checked }) => {
										checkHandlerTemplate(checked);
									}}
								/>
							</div>
							<Dropdown
								placeholder="Seleccione una o varias Plantillas"
								fluid
								selection
								value={template}
								clearable
								search
								multiple
								disabled={state === "sinenviar"}
								// className={styles.dropdownTemplate}
								onChange={(e, { value }) => {
									return templateHandler(value);
								}}
								options={templateOption}
							/>
						</Form.Field>
					</Grid.Column>
					{!isEmpty(company.groups) && (
						<Grid.Column className={styles.stateSend}>
							<Form.Field>
								<label className={styles.text}>Grupos:</label>
								<Dropdown
									placeholder="Seleccione un Grupo"
									fluid
									selection
									value={group}
									clearable
									search
									scrolling
									onChange={(e, { value }) => {
										return groupHandler(value);
									}}
									options={optionGroup}
								/>
							</Form.Field>
						</Grid.Column>
					)}
				</Grid.Row>

				<Grid.Row columns={2} className={styles.row}>
					<Grid.Column>
						<label className={styles.text}>Fecha de Envío:</label>
						<Input
							type="date"
							value={startDateSent}
							onChange={(e) => {
								return setStartDateSent(e.target.value);
							}}
							className={styles.widthInput}
							max={moment().format("YYYY-MM-DD")}
						/>
					</Grid.Column>
					<Grid.Column>
						<label className={styles.text}>hasta</label>
						<Input
							type="date"
							value={endDateSent}
							min={startDateSent ? moment(startDateSent).format("YYYY-MM-DD") : undefined}
							max={moment().format("YYYY-MM-DD")}
							onChange={(e) => {
								return setEndDateSent(e.target.value);
							}}
							className={styles.widthInput}
						/>
					</Grid.Column>
				</Grid.Row>

				<Grid.Row columns={2}>
					<Grid.Column>
						<label className={styles.text}>Fecha Confirmación:</label>
						<Input
							type="date"
							value={startDateConfirmed}
							onChange={(e) => {
								return setStartDateConfirmed(e.target.value);
							}}
							className={styles.widthInput}
							max={moment().format("YYYY-MM-DD")}
						/>
					</Grid.Column>
					<Grid.Column>
						<label className={styles.text}>hasta</label>
						<Input
							type="date"
							value={endDateConfirmed}
							min={startDateSent ? moment(startDateConfirmed).format("YYYY-MM-DD") : undefined}
							max={moment().format("YYYY-MM-DD")}
							onChange={(e) => {
								return setEndDateConfirmed(e.target.value);
							}}
							className={styles.widthInput}
						/>
					</Grid.Column>
				</Grid.Row>

				<Grid.Row columns={2} className={styles.row}>
					<Grid.Column>
						<Form.Field>
							<label className={styles.text}>Contacto</label>
							<Input
								icon="user"
								iconPosition="left"
								placeholder="Nombre"
								value={name}
								onChange={(e) => {
									return setName(e.target.value);
								}}
							/>
						</Form.Field>
					</Grid.Column>
					<Grid.Column>
						<Form.Field>
							<label className={styles.text}>Teléfono</label>
							<Input
								icon="phone"
								iconPosition="left"
								placeholder="Contacto"
								value={phone}
								onChange={(e) => {
									return setPhone(e.target.value);
								}}
							/>
						</Form.Field>
					</Grid.Column>
				</Grid.Row>
			</Grid>
		</IKModal>
	);
};

FilterForm.propTypes = {
	onFilter: PropTypes.func,
	onClose: PropTypes.func,
	channel: PropTypes.string,
	setChannel: PropTypes.func,
	template: PropTypes.string,
	setTemplate: PropTypes.func,
	startDateSent: PropTypes.string,
	setStartDateSent: PropTypes.func,
	endDateSent: PropTypes.string,
	setEndDateSent: PropTypes.func,
	startDateConfirmed: PropTypes.string,
	setStartDateConfirmed: PropTypes.func,
	endDateConfirmed: PropTypes.string,
	setEndDateConfirmed: PropTypes.func,
	name: PropTypes.string,
	setName: PropTypes.func,
	phone: PropTypes.string,
	setPhone: PropTypes.func,
	channelAll: PropTypes.bool,
	setChannelAll: PropTypes.func,
	templateAll: PropTypes.bool,
	setTemplateAll: PropTypes.func,
	templateOption: PropTypes.array,
	channelOption: PropTypes.array,
	templateTable: PropTypes.string,
	setTemplateTable: PropTypes.func,
	state: PropTypes.array,
	setState: PropTypes.func,
	group: PropTypes.array,
	setGroup: PropTypes.func,
	optionGroup: PropTypes.array,
	company: PropTypes.object,
	setIsFilterFirtTime: PropTypes.func,
};

export default connect()(FilterForm);
